// Flow types automatically removed

const uniqueId = (function () {
    let counter = 0;
    return prefix => `${prefix}-${counter++}`;
})();

function addAttributes(element, attributes = {}) {
    Object.keys(attributes).forEach(attr => {
        const attributeValue = attributes[attr];

        element[attr] = attributeValue;
    });
}

function appendElementToDOM(element, baseElement = document.body) {
    if (baseElement) {
        baseElement.appendChild(element);
    }
}

function removeElementFromDOM(element) {
    if (element.parentNode) {
        element.parentNode.removeChild(element);
    }
}

function setUpForm(url, data = {}, attributes = {}) {
    const form = document.createElement('form');
    form.style.display = 'none';
    addAttributes(form, {
        method: 'post',
        action: url,
        enctype: 'multipart/form-data',
        ...attributes,
    });
    Object.keys(data).forEach(key => {
        const keyValue = data[key];
        let input;

        if (keyValue instanceof window.HTMLInputElement) {
            input = keyValue.cloneNode();
            addAttributes(input, {
                name: key,
            });
        } else {
            input = document.createElement('input');
            addAttributes(input, {
                type: 'text',
                name: key,
                value: keyValue,
            });
        }

        form.appendChild(input);
    });
    return form;
}

function setUpIframe(attributes = {}) {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    addAttributes(iframe, attributes);
    return iframe;
}

export function post(url, data) {
    const form = setUpForm(url, data);
    appendElementToDOM(form);
    form.submit();
}
export function postToIframe(url, data) {
    const target = uniqueId('Iframe-Post');
    const iframe = setUpIframe({
        name: target,
    });
    const form = setUpForm(url, data, {
        target,
    });
    appendElementToDOM(iframe);
    appendElementToDOM(form);
    const responsePromise = new Promise(resolve => {
        iframe.onload = () => {
            resolve();
            removeElementFromDOM(iframe);
            removeElementFromDOM(form);
        };
    });
    form.submit();
    return responsePromise;
}
export function postFakeForm(url = '', data = {}) {
    return new Promise((resolve, reject) => {
        const fd = new window.FormData();
        Object.keys(data).forEach(key => {
            fd.append(key, data[key]);
        });
        const xhr = new window.XMLHttpRequest();
        xhr.open('POST', url, true);

        xhr.onreadystatechange = () => {
            try {
                const { responseText, readyState, status } = xhr;
                resolve({
                    readyState,
                    responseText,
                    status,
                });
            } catch (e) {
                reject(e);
            }
        };

        xhr.send(fd);
    });
}
